<template>
  <div
    class="d-flex align-items-center px-2 py-2"
    style="height: 55px">
    <div
      class="pointer me-1"
      @click="toggleAudio">
      <img :src="audioEnabled ? '/assets/icon/v2-icon-pause.svg' : '/assets/icon/v2-icon-play.svg'" />
    </div>
    <div
      class="sound-bar-1"
      :class="!audioEnabled && 'stopped'"
      id="left-bar"></div>
    <div
      class="sound-bar-2"
      :class="!audioEnabled && 'stopped'"
      id="middle-bar"></div>
    <div
      class="sound-bar-3"
      :class="!audioEnabled && 'stopped'"
      id="right-bar"></div>
    <span class="font-13 ms-1">{{ currentTime }}</span>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: "ChatVoice",
  props: ["src"],
  components: {},
  data() {
    return {
      options: {},
      state: false,
      currentTime: "00:00",
      audioEnabled: false,
    };
  },
  methods: {
    onClickVoice() {},
    updateCurrentTime(time) {
      this.currentTime = time;
    },
    loaded() {},
    toggleAudio() {
      this.audioEnabled = !this.audioEnabled;
      if (this.audioEnabled) {
        this.audio.play();
      } else {
        this.audio.pause();
        this.leftBarHeight = 0;
        this.middleBarHeight = 0;
        this.rightBarHeight = 0;
      }
    },
    updateTime() {
      const currentMinutes = Math.floor(this.audio.currentTime / 60);
      const currentSeconds = Math.floor(this.audio.currentTime % 60);
      this.currentTime = currentMinutes.toString().padStart(2, "0") + ":" + currentSeconds.toString().padStart(2, "0");
    },
    simulateSound() {
      if (this.audioEnabled) {
        const soundLevel = Math.floor(Math.random() * 101);
        this.leftBarHeight = soundLevel * 0.5;
        this.middleBarHeight = soundLevel * 0.9;
        this.rightBarHeight = soundLevel;
      }
    },
    handleAudioEnded() {
      this.audioEnabled = false;
    },
  },
  mounted() {
    this.audio = new Audio(this.src);
    this.audio.addEventListener("timeupdate", this.updateTime);
    this.audio.addEventListener("ended", this.handleAudioEnded);
  },
};
</script>

<style lang="scss" scoped>
.sound-bar-1, .sound-bar-2, .sound-bar-3 {
  width: 5px;
  height: 35px;
  background-color: #2970DD;
  margin: 0 2px;
  display: inline-block;
  border-radius: 3px;
}

.sound-bar-1 {
  height: 20px;
}
.sound-bar-2 {
  height: 32px;
}
.sound-bar-3 {
  height: 16px;
}

#left-bar {
  animation: sound-animation-left 0.3s infinite alternate;
}

#middle-bar {
  animation: sound-animation-middle 0.5s infinite alternate;
}

#right-bar {
  animation: sound-animation-right 0.3s infinite alternate;
}

@keyframes sound-animation-left {
  0% {
    height: 5px;
  }
  100% {
    height: 24px;
  }
}

@keyframes sound-animation-middle {
  0% {
    height: 24px;
  }
  100% {
    height: 10px;
  }
}

@keyframes sound-animation-right {
  0% {
    height: 5px;
  }
  100% {
    height: 24px;
  }
}

.stopped {
  animation: none !important;
}
</style>